import { useCallback, useMemo } from 'react';

import { useGetCrmTaskByIdQuery } from '@app/api/CrmTasks';
import { useUserPrint } from '@app/hooks';
import { useTaskListContext } from '@app/providers/TaskListProvider';

interface UseLeadCompletedTaskMessageParams {
  taskId: number;
}

export const useLeadCompletedTaskMessage = ({
  taskId,
}: UseLeadCompletedTaskMessageParams) => {
  const {
    params: { ActiveBranchId },
  } = useUserPrint();
  const { openPreviewTaskModal } = useTaskListContext();

  // Тип и текст задачи в записи истории не приходят: завершение меняет только
  // время выполнения и исполнителя, а в ClientCrmTasks карточки лида лежат
  // только незавершённые задачи. Поэтому задача берётся точечно по ObjectId —
  // RTK Query кеширует ответ, так что на одну задачу приходится один запрос.
  const { data: task } = useGetCrmTaskByIdQuery(
    { id: taskId, ActiveBranchId },
    { skip: !ActiveBranchId }
  );

  const taskLine = useMemo(() => {
    const taskTypeName = task?.TaskType?.trim() ?? '';
    const description = task?.Description?.trim() ?? '';

    return [taskTypeName, description].filter(Boolean).join(': ');
  }, [task?.Description, task?.TaskType]);

  const openTask = useCallback(() => {
    openPreviewTaskModal(taskId);
  }, [openPreviewTaskModal, taskId]);

  return { taskLine, openTask };
};
